import { FC } from 'react';
import { Divider, Icon } from 'common-components';
import { activityEventProps } from './activityEventTypes';
import styles from './activityEvent.module.scss';

const actionAndEntitiesIcons = {
    logged_in: 'logIn',
    logged_out: 'logOut',
    register: 'register',
    start: 'start',
    complete: 'complete',
    create: 'create',
    delete: 'deleteEvent',
    activate: 'activate',
    deactivate: 'deactivate',
    lock: 'lock',
    upload: 'upload',
    invite: 'invite',
    set_primary_course: 'setPrimaryCourse',
    user: 'user',
    users: 'usersEvent',
    lesson: 'lesson',
    course: 'course',
    learningPath: 'learningPath',
    skillTree: 'skillTreeEvent',
    assessment: 'assessment',
    videoTutorial: 'videoTutorial'
};

const ActivityEvent: FC<activityEventProps> = (props: activityEventProps) => {
    const { action, entity } = props;
    return (
        <div className={styles.wrapper}>
            <Icon key={actionAndEntitiesIcons[action]} name={actionAndEntitiesIcons[action]} className={styles.icon} />
            <Divider orientation="vertical" color="rgba(113, 101, 150, 0.30)" className={styles.divider} />
            <Icon key={actionAndEntitiesIcons[entity]} name={actionAndEntitiesIcons[entity]} className={styles.icon} />
        </div>
    );
};

export default ActivityEvent;
